import React, { useContext } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { PatientAssignmentContext } from '../../../context/PatientContext/PatientAssignmentContext';
import { useTranslation } from 'react-i18next';
import { usePatientModal } from "../../../context/PatientModalContext/PatientModalContext";

const PatientAssignmentTable = () => {
  const { t } = useTranslation();
  const {
    assignments,
    total,
    page,
    pageSize,
    loading,
    setPage,
    setPageSize,
  } = useContext(PatientAssignmentContext);
  const { showModal } = usePatientModal();

  const columns = [
    { field: 'memberType', headerName: t("PatientAssignment.PatientAssignmentTable.MemberType"), flex: 1 },
    { field: 'cipId', headerName: t("PatientAssignment.PatientAssignmentTable.CIPID"), flex: 1 },
    { field: 'memberId', headerName: t("PatientAssignment.PatientAssignmentTable.MemberID"), flex: 1 },
    { field: 'fullName', headerName: t("PatientAssignment.PatientAssignmentTable.FullName"), flex: 2 },
    { field: 'age', headerName: t("PatientAssignment.PatientAssignmentTable.Age"), flex: 0.5 },
    { field: 'ageRange', headerName: t("PatientAssignment.PatientAssignmentTable.AgeRange"), flex: 1 },
    { field: 'gender', headerName: t("PatientAssignment.PatientAssignmentTable.Gender"), flex: 0.5 },
    { field: 'isHighRisk', headerName: t("PatientAssignment.PatientAssignmentTable.HighRisk"), flex: 0.7 },
    { field: 'isHighCost', headerName: t("PatientAssignment.PatientAssignmentTable.HighCost"), flex: 0.7 },
    { field: 'location', headerName: t("PatientAssignment.PatientAssignmentTable.Location"), flex: 1 },
    { field: 'pcpFullName', headerName: t("PatientAssignment.PatientAssignmentTable.PCP"), flex: 2 },
  ];



  const handleRowClick = (params) => {
    showModal(params.row.cipId); // 👈 usamos `cipId` porque así se llama el campo en esta tabla
  };

  return (
    <div style={{ height: '700px', width: '100%' }}>
   <DataGrid
        rows={assignments}
        columns={columns}
        rowCount={total}
        loading={loading}
        paginationMode="server"
        paginationModel={{ page, pageSize }} // 👈 ¡Esto es lo que faltaba!
        onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
        }}
        onRowClick={handleRowClick} 
        rowsPerPageOptions={[10, 25, 50, 100]}
        />

    </div>
  );
};

export default PatientAssignmentTable;
